import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { DocumentosPersonalesService } from '@/shared/services/GestionCasosApi/Autenticacion.service';
import type { PersonalDocumentUser } from '@/shared/types/interfaces/DocumentoPersonalUsuario.interface';

const DOCUMENTOS_PERSONALES_QUERY_KEY = ['documentosPersonales'];

export const useObtenerDocumentosPersonalesUsuario = () => {
  return useQuery<PersonalDocumentUser[]>({
    queryKey: DOCUMENTOS_PERSONALES_QUERY_KEY,
    queryFn: () => DocumentosPersonalesService.obtenerDocumentosPersonalesUsuario(),
  });
};

export const useObtenerDocumentoPersonalUsuario = (idUsuario: number | null | undefined, idTipo: number | null | undefined) => {
  return useQuery<PersonalDocumentUser>({
    queryKey: [...DOCUMENTOS_PERSONALES_QUERY_KEY, 'detalle', idUsuario, idTipo],
    queryFn: () => DocumentosPersonalesService.obtenerDocumentoPersonalUsuario(idUsuario as number, idTipo as number),
    enabled: !!idUsuario && !!idTipo,
  });
};

export const useAddPersonalFile = () => {
  const queryClient = useQueryClient();
  return useMutation<PersonalDocumentUser, any, { IdTipo: number; Base64: string; NombreDocumento: string }>({
    mutationFn: (doc) => DocumentosPersonalesService.addPersonalFile(doc),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DOCUMENTOS_PERSONALES_QUERY_KEY });
    },
  });
};

export const useUpdatePersonalFile = () => {
  const queryClient = useQueryClient();
  return useMutation<PersonalDocumentUser, any, { idPersonalDocumentUser: number; updates: { IdTipo: number; Base64: string; NombreDocumento: string } }>({
    mutationFn: ({ idPersonalDocumentUser, updates }) => DocumentosPersonalesService.updatePersonalFile(idPersonalDocumentUser, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DOCUMENTOS_PERSONALES_QUERY_KEY });
    },
  });
};

export const useDeletePersonalFile = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, number>({
    mutationFn: (idPersonalDocumentUser) => DocumentosPersonalesService.deletePersonalFile(idPersonalDocumentUser),
    onSuccess: (_data, idPersonalDocumentUser) => {
      // Actualizar cache local para remover el documento inmediatamente
      queryClient.setQueryData<PersonalDocumentUser[] | undefined>(DOCUMENTOS_PERSONALES_QUERY_KEY, (old) =>
        old ? old.filter((d) => d.idPersonalDocumentUser !== idPersonalDocumentUser) : old
      );
      // Asegurar refetch por si el backend tiene cambios adicionales
      queryClient.invalidateQueries({ queryKey: DOCUMENTOS_PERSONALES_QUERY_KEY });
    },
  });
};

export default {
  useObtenerDocumentosPersonalesUsuario,
  useObtenerDocumentoPersonalUsuario,
  useAddPersonalFile,
  useUpdatePersonalFile,
  useDeletePersonalFile,
};
